import { useState } from 'react'

import { overflowOut, ru } from '../../lib/physics'
import { Predict, Slider, useFrames } from './common'

/**
 * Отливной сосуд (урок 6): тело не лезет в мензурку. Сосуд налит до носика; опускаем тело —
 * вода вытекает через носик в мензурку. Вытекло ровно столько, сколько места заняло тело.
 */

const МЕНЗУРКА = 300 // мл
const ДНО = 260

export default function OverflowLab() {
  const [объём, setОбъём] = useState(180) // см³
  const [глубина, setГлубина] = useState(0) // 0…1
  const [идёт, setИдёт] = useState(false)

  const вытекло = overflowOut(объём, глубина)
  const размер = Math.cbrt(объём) * 9
  const уровень = 110 // уровень воды в сосуде — у носика, не меняется
  const низТела = 70 + глубина * (уровень - 70 + размер + 10)
  const pxНаМл = 140 / МЕНЗУРКА

  useFrames((dt) => {
    if (!идёт) return
    setГлубина((g) => {
      const n = g + dt * 0.35
      if (n >= 1) {
        setИдёт(false)
        return 1
      }
      return n
    })
  })

  const льётся = идёт && низТела > уровень
  const готово = глубина >= 1 && !идёт

  return (
    <div className="card">
      <svg className="lab-svg" viewBox="0 0 360 280" role="img" aria-label="Отливной сосуд и мензурка">
        {/* отливной сосуд с носиком */}
        <rect x={40} y={уровень} width={140} height={ДНО - уровень} className="fill-earth" />
        <path d={`M40 60 V${ДНО} H180 V${уровень - 6} L215 ${уровень + 4}`} className="ink" fill="none" strokeWidth={2.5} />
        <line x1={180} y1={60} x2={180} y2={уровень - 12} className="ink" strokeWidth={2.5} />
        {льётся && <path d={`M214 ${уровень + 4} Q240 ${уровень + 20} 250 ${ДНО - вытекло * pxНаМл - 4}`} className="ink-el" fill="none" strokeWidth={3} />}
        {/* тело на нити */}
        <line x1={110} y1={0} x2={110} y2={низТела - размер} className="ink" strokeWidth={1} />
        <rect x={110 - размер / 2} y={низТела - размер} width={размер} height={размер} rx={6} className="fill-muted ink" strokeWidth={1} />
        {/* мензурка */}
        <rect x={230} y={ДНО - вытекло * pxНаМл} width={50} height={вытекло * pxНаМл} className="fill-earth" />
        <rect x={230} y={ДНО - МЕНЗУРКА * pxНаМл} width={50} height={МЕНЗУРКА * pxНаМл} className="ink" fill="none" strokeWidth={2} />
        {Array.from({ length: МЕНЗУРКА / 50 + 1 }, (_, i) => (
          <g key={i}>
            <line x1={280} y1={ДНО - i * 50 * pxНаМл} x2={272} y2={ДНО - i * 50 * pxНаМл} className="ink" strokeWidth={0.8} />
            <text x={285} y={ДНО - i * 50 * pxНаМл + 3} className="lab-tick">{i * 50}</text>
          </g>
        ))}
        <text x={285} y={ДНО - МЕНЗУРКА * pxНаМл - 10} className="lab-tick">мл</text>
      </svg>

      <div className="lab-readout">
        <span>объём тела V = {ru(объём, 0)} см³</span>
        <span className="el">вытекло в мензурку: {ru(вытекло, 0)} мл</span>
      </div>
      {готово && <div className="lab-caption">Тело под водой целиком — вытекло {ru(вытекло, 0)} мл, это и есть его объём.</div>}

      <Slider label="Размер тела" value={объём} min={40} max={280} step={5} unit="см³" onChange={(v) => { setОбъём(v); setГлубина(0); setИдёт(false) }} />
      <div className="row-wrap" style={{ marginTop: 12 }}>
        <button className="btn btn-primary" onClick={() => { setГлубина(0); setИдёт(true) }}>⬇️ Опустить тело</button>
      </div>

      <Predict
        question="Сосуд налит до носика. Сколько воды вытечет, когда в него целиком опустят тело объёмом 180 см³?"
        options={['меньше 180 мл', 'ровно 180 мл', 'больше 180 мл']}
        right={1}
        revealed={готово && объём === 180}
        explain="Вода в сосуде уже стоит у носика, поэтому всё, что вытеснило тело, вытекает: 180 см³ = 180 мл."
      />
      <p className="muted small">
        Перед опытом сосуд наливают с избытком и ждут, пока лишнее стечёт, — иначе в мензурку попадёт
        и вода, которую тело не вытесняло.
      </p>
    </div>
  )
}
